import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Chip } from "@opensea/ui-kit";
import { CoinbaseOne } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
export const ProfileCoinbaseOneChipFragment = graphql(`
  fragment ProfileCoinbaseOneChip on Profile {
    isCoinbaseOne
  }
`);
export function ProfileCoinbaseOneChip(t0) {
  const $ = _c(6);
  const {
    profile: profileKey,
    chipVariant
  } = t0;
  const profile = readFragment(ProfileCoinbaseOneChipFragment, profileKey);
  const t = useTranslations("ProfileCoinbaseOneChip");
  if (!profile.isCoinbaseOne) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CoinbaseOne size={12} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("label");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== chipVariant || $[4] !== t2) {
    t3 = <Chip className="gap-1 border-[#4d86ff]/40 bg-gradient-to-b from-[#4d86ff]/25 to-[#4d86ff]/15 text-[#4d86ff]" variant={chipVariant}>{t1}{t2}</Chip>;
    $[3] = chipVariant;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}